import React from 'react'
import styled from 'styled-components'
import { Select } from 'antd'
import { SelectValue } from 'antd/lib/select'
import { MapMetric, useGetMapMetrics } from '../../services/map-metrics.service'

type Props = {
    handleMetricSelection: (metric: MapMetric) => void,
    selectedMetric: MapMetric
}

export const MapMetricSearch: React.FC<Props> = ({handleMetricSelection, selectedMetric}) => {
  const metricsRequest = useGetMapMetrics();
  const metrics = metricsRequest.data || [];
  const { Option } = Select;

  const onChange = (value: SelectValue) => {
    const selectedMetric = metrics.find(it => it.id === value)
    if (selectedMetric) {
      handleMetricSelection(selectedMetric);
    }
  }
  
  return (
    <div>
      <label>Indicador</label>
      <SearchBar
        size="large"
        showSearch
        placeholder="Comienza a escribir para buscar entre los indicadores"
        optionFilterProp="children"
        onChange={onChange}
        value={selectedMetric.id}
      >
        {metrics.map((se: any) => (
          <Option key={se.id} value={se.id}>
            {se.name}
          </Option>
        ))}
      </SearchBar>
    </div>
  )
}

const SearchBar = styled(Select)`
  width: 100%;
  margin-bottom: 10px;
`
